<template>

  <div>

    <ACard>
      <div class="flex items-center justify-between">
        <h3 class="mb-0">Billing</h3>
        <div class="space-x-2">
          <a-button type="primary" ghost @click="recordPayment" style="border-radius: 3px !important;">Record payment</a-button>
          <!--            <a-button type="primary" @click="addQuickBill" style="border-radius: 3px !important;">New Bill</a-button>-->
          <a-dropdown-button type="primary" @click="addQuickBill" style="border-radius: 3px !important;">
            New bills
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="open_fund_client = true">New client fund request </a-menu-item>
              <!--                <a-menu-item key="2">New statements of account</a-menu-item>-->
            </a-menu>
            <a-icon slot="icon" type="down" />
          </a-dropdown-button>
        </div>
      </div>
    </ACard>

    <ACard class="mt-5">
      <a-tabs v-model="tab_bill" default-active-key="1" @tabClick="tabClick">
        <a-tab-pane key="1" tab="Bill" force-render>
          <ACard title="Filters">
            <div class="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <a-select
                default-value="all"
                @select="filterStatus"
                placeholder="Select a billing type"
                style="width: 250px"
                allow-clear
                v-model="billing_type"
              >
                <a-select-option value="all">
                  All
                </a-select-option>
                <a-select-option :value="1">
                  Draft
                </a-select-option>
                <a-select-option :value="2">
                  Approve
                </a-select-option>
                <a-select-option :value="3">
                  Unpaid
                </a-select-option>
                <a-select-option :value="4">
                  Paid
                </a-select-option>
              </a-select>
              <!--          <vs-button color="primary"-->
              <!--                     type="border"-->
              <!--                     icon="filter_list"-->
              <!--                     @click="showDrawer"-->
              <!--                     style="letter-spacing: 0.6px"-->
              <!--          >-->
              <!--            Filters-->
              <!--          </vs-button>-->
            </div>
          </ACard>
          <XTable
            class="mt-5"
            ref="bill"
            :model="model"
            @clickRow="clickRow"
            @refresh="refreshBill"
            :options="{ placeholder:'Search bill',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.id }}</a-button>
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.to_contact">
                <template v-if="text.record.to_contact.person">
                   {{ text.record.to_contact.person.first_name }} {{  text.record.to_contact.person.last_name  }}
                </template>
                <template v-else>
                   {{ text.record.to_contact.company.name }}
                </template>
            </span>
            <span slot="matter" slot-scope="text,record,index" class="flex flex-row">
                <div v-for="matter in text.record.matters">
                  <vs-chip color="primary">
                    {{ matter.title }}
                  </vs-chip>
              </div>
            </span>
            <span slot="level" slot-scope="text,record">
          <template v-if="text.record.detail_level === 1">
            All Details
          </template>
          <template v-else-if="text.record.detail_level === 2">
            Activity Summery
          </template>
          <template v-else-if="text.record.detail_level === 3">
            Aggregate
          </template>
        </span>
            <span slot="first_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="second_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_second_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="third_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_skip_approval_process"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="status" slot-scope="text,record">
          <template v-if="text.record.status === 1">
            <a-tag color="purple">
              Draft
            </a-tag>
          </template>
          <template v-else-if="text.record.status === 2">
            <a-tag color="blue">
              Approve
            </a-tag>
          </template>
          <template v-else-if="text.record.status === 3">
            <a-tag color="yellow">
              Unpaid
            </a-tag>
          </template>
          <template v-else-if="text.record.status === 4">
              <a-tag color="green">
                Paid
              </a-tag>
          </template>
        </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBill(text.record)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,true)" v-if="text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Skip approve bill</a-menu-item>
                    <a-menu-item key="4" @click="OpenSendEmail(text.record,true)" v-if="text.record.status === 2"><feather-icon icon="MailIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Send</a-menu-item>
                    <a-menu-item key="5" @click="InvoiceDisplay(text.record,true)"><feather-icon icon="MonitorIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Invoice display</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Client fund" force-render>
          <XTable
            class="mt-5"
            ref="ClientFund"
            :model="modelClientFund"
            @refresh="refreshFundClient"
            :options="{ placeholder:'Search client fund',noContent: 'No outstanding',is_row_selection: false,is_load_req: false,temp_row: null }"
          >

            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.id }}</a-button>
            </span>

            <span slot="contact" slot-scope="text,record">
              <template v-if="text.record.to_contact.person">
                {{ text.record.to_contact.person.first_name }} {{ text.record.to_contact.person.last_name }}
              </template>
              <template v-else>
                {{ text.record.to_contact.company.name }}
              </template>
            </span>

            <span slot="status" slot-scope="text,record">
              <template v-if="text.record.status === 1">
                <a-tag color="purple">
                  Draft
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 2">
                <a-tag color="blue">
                  Approve
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 3">
                <a-tag color="yellow">
                  Unpaid
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 4">
                  <a-tag color="green">
                    Paid
                  </a-tag>
              </template>
            </span>

            <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
              {{ text.record.matter.title }}
            </span>

            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBillClientFund(text.record)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,false)" v-if="text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Skip approve bill</a-menu-item>
                    <a-menu-item key="4" @click="OpenSendEmail(text.record,false)" v-if="text.record.status === 2"><feather-icon icon="MailIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Send</a-menu-item>
                    <a-menu-item key="5" @click="InvoiceDisplay(text.record,false)"><feather-icon icon="MonitorIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Invoice display</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>

          </XTable>
        </a-tab-pane>
      </a-tabs>
    </ACard>



    <deleteItem
      :url="`/billing/${temp_row}/`"
      subject="Bill"
      :ele="$refs.bill"
      ref="billDelete"
    />

    <deleteItem
      :url="`/billing/fund-request/${temp_row}/`"
      subject="Bill"
      :ele="$refs.ClientFund"
      ref="billDeleteClientFund"
    />
    <a-modal centered class="billing" title="Generate Invoices" :visible="open_edit_billing" @cancel="open_edit_billing = false" :width="750">
      <a-form :form="form" @submit.prevent="handleEditBill">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a-form-item label="Issue date" has-feedback>
            <a-date-picker
              v-decorator="['issue_date',{ initialValue: new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
          <a-form-item label="Due date" has-feedback>
            <a-date-picker
              v-decorator="['due_date',{ initialValue:new Date().toISOString().split('T')[0] ,rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
        </div>

        <a-form-item label="Detail Level" has-feedback>
          <a-select
            placeholder="condition"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['detail_level',{ initialValue: '1' }]"
          >
            <a-select-option value="1">
              All Details
            </a-select-option>
            <a-select-option value="2">
              Activity Summary
            </a-select-option>
          </a-select>
        </a-form-item>

        <p class="mt-5">Options:</p>
        <div class="flex">
          <a-form-item>
            <a-checkbox v-decorator="['is_apply_task',{ initialValue: false, valuePropName: 'checked' }]">
              Apply tax
            </a-checkbox>
          </a-form-item>
<!--          <a-form-item>-->
<!--            <a-checkbox v-decorator="['is_apply_second_task',{ initialValue: false, valuePropName: 'checked' }]">-->
<!--              Apply secondary tax-->
<!--            </a-checkbox>-->
<!--          </a-form-item>-->
          <a-form-item>
            <a-checkbox v-decorator="['is_skip_approval_process',{ initialValue: false, valuePropName: 'checked' }]">
              Skip the bill approval process
            </a-checkbox>
          </a-form-item>
        </div>

        <a-divider/>

        <div class="flex space-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="border" ghsot style="border-radius: 3px" @click="open_generate = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <a-modal centered class="billing" title="New client funds request" :visible="open_fund_client" @cancel="open_fund_client = false" :width="750">
      <a-form :form="form_client_fund" @submit.prevent="handleClientFundBill">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a-form-item label="Due date" has-feedback>
            <a-date-picker
              v-decorator="['due_date',{ initialValue:new Date().toISOString().split('T')[0] ,rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>

          <selectSearch
            url="/contact/query/"
            :required="true"
            @selectSearchValue="selectSearchValue"
            :options="{ label:'Client',field: 'client',placeholder: 'Type to search client',allow_clear:true }"
          />

          <a-form-item label="Balance type" has-feedback>
            <a-select
              style="width: 100%"
              allowClear
              class="select"
              v-decorator="['balance',{ initialValue: '1' }]"
              @select="handleSelectType"
            >
              <a-select-option value="1">
                Client
              </a-select-option>
              <a-select-option value="2">
                Matter
              </a-select-option>
            </a-select>
          </a-form-item>

        </div>

        <ACard class="mt-5" v-if="is_client_type">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!--            <selectSearch-->
            <!--                :required="true"-->
            <!--                url="/matter/query/"-->
            <!--                :options="optionSearchMatter"-->
            <!--                class="self-center mt-8 md:mt-0 w-full"-->
            <!--                :is_include_matter="true"-->
            <!--                ref="matter"-->
            <!--              />-->
            <a-form-item label="Matter" has-feedback>
              <a-select
                placeholder="Select source matter"
                allowClear
                class="select"
                v-decorator="['matter',{rules: [{ required: true, message: 'This field is required.' }] }]"
              >
                <a-select-option v-for="matter in matters" :value="matter.id">
                  {{ matter.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Amount" has-feedback>
              <a-input
                placeholder="0.00"
                style="width: 100%"
                allowClear
                class="select"
                v-decorator="['total_amount',{ rules: [{ required: true, message: 'This filed is required.' }] }]"
              />
            </a-form-item>
          </div>
        </ACard>
        <a-form-item v-else label="Amount" has-feedback>
          <a-input
            placeholder="0.00"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['total_amount',{ rules: [{ required: true, message: 'This filed is required.' }] }]"
          />
        </a-form-item>


        <a-form-item label="Note" has-feedback>
          <a-textarea
            style="width: 100%"
            class="select"
            v-decorator="['note',{ rules: [{ required: false, message: 'This filed is required.' }] }]"
          />
        </a-form-item>

        <!--        <a-form-item>-->
        <!--          <a-checkbox-->
        <!--            style="width: 100%"-->
        <!--            class="select"-->
        <!--            v-decorator="['skip_client',{ rules: [{ required: false, message: 'This filed is required.' }] }]"-->
        <!--          >-->
        <!--            Skip the client funds request approval process-->
        <!--          </a-checkbox>-->
        <!--        </a-form-item>-->


        <a-divider/>

        <div class="flex space-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="border" ghsot style="border-radius: 3px" @click="open_fund_client = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <a-modal centered class="billing" title="Send item" :visible="open_send_email" @cancel="open_send_email = false" :width="750">
      <a-form :form="form_send" @submit.prevent="handleSendBill">

        <a-form-item label="Contacts" has-feedback>
          <a-select
            style="width: 100%"
            allowClear
            class="select"
            mode="multiple"
            show-search
            :filter-option="filterOption"
            v-decorator="['to_contacts',{rules: [{ required: true, message: 'This filed is required.' }]}]"
          >
            <a-select-option v-for="contact in contacts" :value="contact.id">
              <template v-if="contact.person">
                {{ contact.person.first_name }} {{ contact.person.last_name }} ({{contact.emails.length ? contact.emails[0].email_address : 'No email'}})
              </template>
              <template v-else>
                {{ contact.company.name }}  {{ (contact.emails.length ? contact.emails[0].email_address : 'No email') }}
              </template>
            </a-select-option>
          </a-select>
        </a-form-item>

        <!--        <p class="text-xl font-semibold mt-5">Message</p>-->

        <!--        <a-form-item label="Email template" has-feedback>-->
        <!--          <a-select-->
        <!--            style="width: 100%"-->
        <!--            allowClear-->
        <!--            class="select"-->
        <!--            v-decorator="['template']"-->
        <!--          >-->
        <!--            <a-select-option :value="1">-->
        <!--                Bills template-->
        <!--            </a-select-option>-->
        <!--            <a-select-option :value="2">-->
        <!--              Default Client Funds template-->
        <!--            </a-select-option>-->
        <!--            <a-select-option :value="3">-->
        <!--              Outstanding Balance template-->
        <!--            </a-select-option>-->
        <!--            <a-select-option :value="4">-->
        <!--              Reminders template-->
        <!--            </a-select-option>-->
        <!--          </a-select>-->
        <!--        </a-form-item>-->

        <a-form-item label="Subject" has-feedback>
          <a-input
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['title',{rules: [{ required: true, message: 'This filed is required.' }]}]"
          >
          </a-input>
        </a-form-item>

        <a-form-item label="Body" has-feedback>
          <a-textarea
            style="width: 100%"
            allowClear
            class="select"
            :rows="5"
            v-decorator="['message',{rules: [{ required: true, message: 'This filed is required.' }]}]"
          >
          </a-textarea>
        </a-form-item>

        <!--        <p class="text-xl font-semibold mt-5">Send bill by</p>-->


        <a-divider/>

        <div class="flex space-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="border" ghsot style="border-radius: 3px" @click="open_send_email = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <a-modal centered class="billing" title="Invoice display" :visible="open_invoice_display" @cancel="open_invoice_display = false" :width="750">
      <ASkeleton active v-if="skeleton_show"/>
      <div v-else v-html="invoice_html"></div>
    </a-modal>


  </div>

</template>


<script>
import * as TableCol from "../billing/billTbl";
// import * as TableColBalance from "../billing/balancesTbl";
// import * as TableColOutstanding from "../billing/outstandingTbl";
import XTable from "../../components/x-table/XTable";
import Mixin from '../mixin/mixin'
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import axios from '@/axios'
import deleteItem from '../communications/deleteItem'

export default {
  name: "billingList",
  mixins:[Mixin],
  components:{
    XTable,
    SelectOption,
    selectSearch,
    deleteItem
  },
  data(){
    return{
      model        : null,
      modelBalance : null,
      modelOutstanding: null,
      modelClientFund: null,
      openQuickBill: false,
      edit_mode    : false,
      temp_row     : undefined,
      row          : undefined,
      contact_value: undefined,
      billing_type : 'all',
      open_edit_billing: false,
      open_fund_client: false,
      open_send_email: false,
      is_client_type: false,
      open_invoice_display: false,
      contacts: [],
      matters: [],
      invoice_html: '',
      skeleton_show: false,
      form_send:  this.$form.createForm(this, {name: 'coordinated'}),
      form_client_fund:  this.$form.createForm(this, {name: 'coordinated'}),
      tab_bill: '1'
    }
  },
  methods:{

    dashboardId(id){
      this.is_click_add_time = true
      this.$router.push(`/billing/dashboard/${id}`)
    },

    async selectSearchValue(value){
      const {data} = await axios.post('matter/query/',{ limit: 9999 ,query:[{ field:'client__id',condition:'=',value: value }]})
      this.matters = data.rows
    },

    async refreshOutstanding(){
      // await this.$refs.outstanding.fetch()
      // const data = this.$refs.outstanding.data
      // const array = Object.values(data)
      // this.$refs.outstanding.data = array
    },

    refreshBill(){
      this.billing_type = 'all'
      this.$refs.bill.query.query = [{ condition: 'in' , value: [this.$route.params.id] , field: 'matters__id'  }]
      // this.$refs.bill.fetch()
    },

    refreshFundClient(){
      this.$refs.ClientFund.query.query = [{ condition: 'in' , value: [this.$route.params.id] , field: 'matter__id'  }]
      // this.$refs.ClientFund.fetch()
    },

    async tabClick(key){
      if(key === '1'){
        this.$refs.bill.data = []
        this.$refs.bill.query.query = [{ condition: 'in' , value: [this.$route.params.id] , field: 'matters__id'  }]
        await this.$refs.bill.fetch()
      }else if(key === '2'){
        this.$refs.ClientFund.data = []
        this.$refs.ClientFund.query.query = [{ condition: 'in' , value: [this.$route.params.id] , field: 'matter__id'  }]
        await this.$refs.ClientFund.fetch()
      }
    },

    async InvoiceDisplay(record,is_bill_invoice){
      try{
        this.open_invoice_display = true
        this.skeleton_show = true
        const { data } = await axios.get(is_bill_invoice ? `/billing/${record.id}/html/` : `/billing/fund-request/${record.id}/html/`)
        this.invoice_html = data
        this.skeleton_show = false
      }catch (e) {
        this.$message.error('Error receiving Data')
        this.open_invoice_display = false
      }
    },

    OpenSendEmail(record,is_send_bill){
      this.open_send_email = true
      this.temp_row = record
      this.temp_row.is_send_bill = is_send_bill
    },

    async getContacts(){
      const { data } = await axios.post('/contact/query/',{ limit: 9999 })
      this.contacts = data.rows
    },

    recordPayment(){
      this.$router.push('/billing/record-payment')
    },

    handleSelectType(value){
      value === '2' ? this.is_client_type = true : this.is_client_type = false
    },

    openApprove(record){
      this.temp_row = record.id
      this.$refs.approveDelete.open = true
    },

    async filterStatus(value){
      this.checkPagenation(this.$refs.bill)
      value === 'all' ? this.$refs.bill.query.query = [] : this.$refs.bill.query.query = [{ field:'status',condition:'=',value: value }]
      await this.$refs.bill.fetch()
    },

    handleSearchContact(value){
      this.contact_value = value
    },

    CancelBill(){
      this.openQuickBill = false
      setTimeout(()=>this.form.resetFields(),200)
    },

    clickRow(record){
      if(this.is_click_add_time && record.status === 1){
        this.open_edit_billing = true
        this.temp_row      = record
        this.$nextTick(()=>{this.getRecordRow(record)})
      }else
        this.is_click_add_time = true
    },

    async ApproveBill(record,ref){
      try{

        ref ? this.$refs.bill.loading = true : this.$refs.ClientFund.loading = true
        await axios.put(ref ?`/billing/${record.id}/` : `/billing/fund-request/${record.id}/`,{ status: 2 })
        ref ? await this.$refs.bill.fetch() : await this.$refs.ClientFund.fetch()
        this.$notification['success']({
          message: 'Success',
          description: `Bill approved.`,
        });
      }catch (e) {
        this.$notification['error']({
          message: 'error',
          description: `Bill approved failed.`,
        });
      }finally {
        ref ? this.$refs.bill.loading = false : this.$refs.ClientFund.loading = false
      }
    },

    async getRecordRow(record){
      try{
        this.$vs.loading()
        const { data } = await axios.get(`/billing/${record.id}/`);
        this.row       = data
        data.detail_level = `${data.detail_level}`
        data.from_user ? data.from_user = data.from_user.id : data.from_user = undefined
        data.matter ? data.matter = data.matter.title : data.matter = undefined
        data.to_contact && data.to_contact.person ? data.to_contact = `${data.to_contact.person.first_name} ${data.to_contact.person.last_name}` : data.to_contact = undefined
        this.form.setFieldsValue(data)
      }catch (e){
        this.$message.error('Server error')
      }finally {
        this.$vs.loading.close()
      }
    },


    deleteBill(record){
      this.temp_row = record.id
      this.$refs.billDelete.open = true
    },

    deleteBillClientFund(record){
      this.temp_row = record.id
      this.$refs.billDeleteClientFund.open = true
    },

    addQuickBill(){
      this.$router.push('/billing/add')
      // this.edit_mode     = false
      // this.openQuickBill = true
    },

    handleClientFundBill(){
      this.form_client_fund.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            values.balance = undefined
            await axios.post('/billing/fund-request/',values)
            this.open_fund_client = false
            this.$notification['success']({
              message: 'Success',
              description: `Client fund created.`,
            });
            this.tab_bill = '3'
            this.$refs.ClientFund.fetch().then(()=>{})
          }catch (e) {
            this.$notification['error']({
              message: 'Failed',
              description: `Client fund failed.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    handleSendBill(){
      this.form_send.validateFields(async(err,values)=>{
        if(!err){
          try{
            let intersection = this.contacts.filter(x => values.to_contacts.includes(x.id));
            const emails = intersection.map(item=>item.emails).flat()
            if(emails.length === 0){
              this.$message.error('The following contact has an invalid email address.')
              return
            }
            this.$vs.loading()
            const {temp_row} = this
            await axios.post(temp_row.is_send_bill ? `/billing/${temp_row.id}/send/` : `/billing/fund-request/${temp_row.id}/send/`,values)
            this.$notification['success']({
              message: 'Success',
              description: `Send Email success.`,
            });
            this.form_send.resetFields()
            this.open_send_email = false
            this.billing_type = 'all'
            this.$refs.bill.query.query = []
            this.$refs.bill.fetch().then(()=>{})
          }catch (e) {
            this.$notification['error']({
              message: 'error',
              description: `Send Email failed.`,
            });
            this.open_send_email = true
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    handleEditBill(){
      this.form.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            values.time_entries    = this.temp_row.time_entries.length    ? this.temp_row.time_entries.map(item=> item.id)    : []
            values.expense_entries = this.temp_row.expense_entries.length ? this.temp_row.expense_entries.map(item=> item.id) : []
            values.matters = this.temp_row.matters.length ? this.temp_row.matters.map(item=>item.id) : []
            values.to_contact = this.temp_row.to_contact.id
            const {id} = this.temp_row
            await axios.put(`/billing/${id}/`,values)
            this.form.resetFields()
            this.open_edit_billing = false
            this.$notification['success']({
              message: 'Success',
              description: `Billing created`,
            });
            this.$refs.bill.fetch().then(()=>{})
          }catch (e) {
            this.$notification['error']({
              message: 'error',
              description: `Billing failed`,
            });
            this.open_edit_billing = true
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

  },
  created() {
    this.model = TableCol.default
    // this.modelBalance = TableColBalance.default
    // this.modelOutstanding = TableColOutstanding.default
    // this.modelClientFund = TableClientFund.default
  },
  mounted() {
    this.is_click_add_time = true
    this.$refs.ClientFund.query.query = [{ condition: 'in' , value: [this.$route.params.id] , field: 'matter__id'  }]
    this.$refs.ClientFund.fetch()
    this.getContacts()

  }
}
</script>

<style>
@import "../style/style.css";
.vs-tabs--ul{
  box-shadow: none !important;
}
[dir=ltr] .ant-tabs-content > [dir] .tab-sub.ant-tabs-tabpane > [dir] .ant-tabs-bar{
  border-bottom: none !important;
}
.billing .ant-modal-footer{
  display: none !important;
}
.ant-btn-group.ant-dropdown-button .ant-btn-primary{
  border-radius: 3px 0 0 3px !important;
}
.ant-btn-group .ant-btn-primary.ant-dropdown-trigger{
  border-radius: 0px 3px 3px 0px !important;
}
</style>




<!--  <vs-card class="pb-3">-->
<!--    <a-tabs default-active-key="1">-->
<!--    <a-tab-pane key="1" tab="Bill" class="tab-sub">-->
<!--      <vs-tabs>-->
<!--        <vs-tab label="Draft">-->
<!--          <div class="con-tab-ejemplo">-->
<!--              <div class="container mx-auto text-center">-->
<!--                <img src="../../../public/Wallet-rafiki.svg" width="400"/>-->
<!--                <h3 class="pt-5">No bills or trust requests found</h3>-->
<!--                <p>Start billing your clients or collect trust deposits upfront.</p>-->
<!--                <div class="flex justify-center space-x-4">-->
<!--                  <vs-button color="primary" type="filled" class="font-bold" @click="addBill">New bill</vs-button>-->
<!--                  <vs-button color="primary" type="border" class="font-bold">New trust request</vs-button>-->
<!--                </div>-->
<!--              </div>-->
<!--              <XTable v-if="false" :model="model"></XTable>-->
<!--          </div>-->
<!--        </vs-tab>-->
<!--        <vs-tab label="Pending approva">-->
<!--          <div class="con-tab-ejemplo">-->
<!--            Service-->
<!--          </div>-->
<!--        </vs-tab>-->
<!--        <vs-tab label="Unpaid">-->
<!--          <div class="con-tab-ejemplo">-->
<!--            login-->
<!--          </div>-->
<!--        </vs-tab>-->
<!--        <vs-tab label="Paid">-->
<!--          <div class="con-tab-ejemplo">-->
<!--            Disabled-->
<!--          </div>-->
<!--        </vs-tab>-->
<!--        <vs-tab label="All">-->
<!--          <div class="con-tab-ejemplo">-->
<!--            Lorem ipsum dolor sit amet-->
<!--          </div>-->
<!--        </vs-tab>-->
<!--      </vs-tabs>-->
<!--&lt;!&ndash;      <a-tabs default-active-key="1">&ndash;&gt;-->
<!--&lt;!&ndash;        <a-tab-pane key="1" tab="Draft">&ndash;&gt;-->

<!--&lt;!&ndash;        </a-tab-pane>&ndash;&gt;-->
<!--&lt;!&ndash;        <a-tab-pane key="2" tab="Pending approva">&ndash;&gt;-->

<!--&lt;!&ndash;        </a-tab-pane>&ndash;&gt;-->
<!--&lt;!&ndash;        <a-tab-pane key="3" tab="Unpaid">&ndash;&gt;-->

<!--&lt;!&ndash;        </a-tab-pane>&ndash;&gt;-->
<!--&lt;!&ndash;        <a-tab-pane key="4" tab="Paid">&ndash;&gt;-->

<!--&lt;!&ndash;        </a-tab-pane>&ndash;&gt;-->
<!--&lt;!&ndash;        <a-tab-pane key="5" tab="All" force-render>&ndash;&gt;-->

<!--&lt;!&ndash;        </a-tab-pane>&ndash;&gt;-->
<!--&lt;!&ndash;      </a-tabs>&ndash;&gt;-->
<!--    </a-tab-pane>-->
<!--    <a-tab-pane key="2" tab="Outstanding Balances" force-render>-->
<!--      <div class="container mx-auto text-center">-->
<!--        <img src="../../../public/Wallet-rafiki.svg" width="400"/>-->
<!--        <h3 class="pt-5">No bills or trust requests found</h3>-->
<!--        <p>Start billing your clients or collect trust deposits upfront.</p>-->
<!--        <div class="flex justify-center space-x-4">-->
<!--          <vs-button color="primary" type="filled" class="font-bold" @click="addBill">New bill</vs-button>-->
<!--          <vs-button color="primary" type="border" class="font-bold">New trust request</vs-button>-->
<!--        </div>-->
<!--      </div>-->
<!--      <XTable v-if="false" :model="modelBalance"></XTable>-->
<!--    </a-tab-pane>-->
<!--    <div slot="tabBarExtraContent" class="flex items-center space-x-4">-->
<!--      <a-button>-->
<!--        record payment-->
<!--      </a-button>-->
<!--      <a-button type="primary" icon="down" >-->
<!--        New bills-->
<!--      </a-button>-->
<!--    </div>-->
<!--    </a-tabs>-->
<!--  </vs-card>-->
